import React, {useState, useEffect} from 'react';
import refreshIcon from '../img/refresh.png';
import Select from 'react-select';
import '../css/App.css';
import '../css/bootstrap.min.css';
import AllNotificationsRow from './AllNotificationsRow';
import Time, {getComputerTime} from '../Time';
import Members from '../users/Members';

class AllNotifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      members:[],
      notifications:[],
      userFrom:'',
      userTo:'',
      date:''
    };
   this.handleFormChange = this.handleFormChange.bind(this);
   this.loadMembers = this.loadMembers.bind(this);
   this.changeFrom = this.changeFrom.bind(this);
   this.changeTo = this.changeTo.bind(this);
  }

  //Everytime you type something on the form it updates the state of this component
  handleFormChange = (e) =>{
      this.setState({[e.target.id]: e.target.value});
      this.loadEverything(this.state.userFrom,this.state.userTo,e.target.value);
  }

  changeFrom = (memberFrom) =>{
    this.setState({userFrom:memberFrom.value})
    this.loadEverything(memberFrom.value,this.state.userTo,this.state.date);
  }

  changeTo = (memberTo) =>{
    this.setState({userTo:memberTo.value})
    this.loadEverything(this.state.userFrom,memberTo.value,this.state.date);
  }

  
  /**
   * Loads all the notifications from the database applying filters
   * 
   * @param  {} from The person who created the notification
   * @param  {} to The person who received the notification
   * @param  {} date The date that the person should already received the notification
   * 
   */
  loadEverything = async(from,to,date) =>{

    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };
    
    fetch("https://dashboard.realsexdoll.info/php/notifications/allnotifications.php?name="+from+"&dateTime="+date+"&to="+to, requestOptions)
      .then(response => response.json())
      .then(result => this.setState({notifications:result}))
      .catch(error => console.log('error', error));

  }

  loadMembers = async()=>{
    let allMembers = await Members.getMembersSelectList()
    allMembers.unshift({value: '', label: 'All employees'})
    this.setState({members:allMembers})
  }
  
  //This runs when the dashboard opens
  componentDidMount(){
    this.loadEverything('','','');
    this.loadMembers();
  }
  
  render() {

    let notificationList;

    if(this.state.notifications.length > 0){
      notificationList = this.state.notifications.map((notification, index) =>
        <AllNotificationsRow

          key={index.toString()}
          i={index}
          deleteNotification={this.removeNotification}
          user={this.state.user}
          link={notification.CompletionRequirementReferenceValue}
          text={notification.NotificationText}
          generatedBy={notification.GeneratedBy}
          snoozeCount={notification.snoozeCount}
          seenDate={notification.seenDateTime}
          priority={notification.Priority}
          date={notification.generatedDate}
          showingDate={notification.showingDate}
          id={notification.notificationId}
          userNotificationId={notification.id}
          refreshAll={this.refreshNotifications}
          to={notification.userName}
          
        />

      )
    }
    
    let memberFrom;
    let memberTo;

    //These are the members available right now
    const members = this.state.members;

    //Builds the member selector
    const selectMemberFrom =
        <Select closeMenuOnSelect={true}  
                options={members}
                onChange={this.changeFrom}
                value={memberFrom}
        />

      const selectMemberTo =
        <Select closeMenuOnSelect={true}  
                options={members}
                onChange={this.changeTo}
                value={memberTo}
        />
   
    return(

    <div>
        <div className='pop-up' onClick={this.props.close}></div>
        <div className="container pop-up-window all-notification-window">
            <div className="row">
                <div className="col-12 container p-4">
                  <h3>All notifications</h3>
                </div>
            </div>
            <div className='row mb-3'>
              <div className='col-2'>
                <label className="form-label">Generated by:</label>
                {selectMemberFrom}
              </div>
              <div className='col-2'>
                <label className="form-label">To employee:</label>
                {selectMemberTo}
              </div>
              <div className='col-2'>
                <label className="form-label">Dispersion Date:</label>
                <input type="date" id='date' onChange={this.handleFormChange} className="form-control"></input>
              </div>
              <div className='col-6'>
                <label className="form-label row">Options (not implemented)</label>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="checkbox" id="completed"></input>
                  <label className="form-check-label" htmlFor="completed">Completed</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="checkbox" id="snoozed"></input>
                  <label className="form-check-label" htmlFor="snoozed">Snoozed</label>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <div className='wrapper mb-5'>
                  <div className="notification-board container-fluid">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th className='col-1'>Priority</th>
                        <th>Notification</th>
                        <th>Generated date</th>
                        <th>Dispersion date</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notificationList}
                    </tbody>
                  </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>

    );
  }
}

export default AllNotifications;